import { v4 as uuidv4 } from "uuid";

/**
 * Very naive random UUIDs for now ^^
 * But the uuid lib has features if random does not cut it.
 */
export const generateCbKey = (): string => uuidv4();
